/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ partners: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Billing_Board_Meta_PlainInputs */



/**
* | output |
* | --- |
* | "{partners} partners · {amount}" |
*
* @param {Partner_Billing_Board_Meta_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_plain = /** @type {((inputs: Partner_Billing_Board_Meta_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.partners} Partner · ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.partners} partners · ${i?.amount}`)
});